import React, { useState, useEffect } from "react";
import BaseForm from "../../../../app/components/BaseForm";
import { motion, AnimatePresence } from "framer-motion";
import Input from "../../../../app/components/Input";
import { FiFolder, FiImage, FiChevronDown, FiChevronRight } from "react-icons/fi";
import { usePageTitle } from '../../../../contexts/PageTitleContext';


const mockData = [
  {
    id: 1,
    name: "Sequence",
    type: "folder",
    children: [
      {
        id: 2,
        name: "Imagens",
        type: "folder",
        children: [
          {
            id: 3,
            name: "2025",
            type: "folder",
            children: [
              {
                id: 4,
                name: "bg-sequence.png",
                type: "image",
                url: "/assets/sequence_gradient.png",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 1,
    name: "Sequence",
    type: "folder",
    children: [
      {
        id: 2,
        name: "Imagens",
        type: "folder",
        children: [
          {
            id: 3,
            name: "2025",
            type: "folder",
            children: [
              {
                id: 4,
                name: "logo.png",
                type: "image",
                url: "/assets/logo_color.svg",
              },
            ],
          },
        ],
      },
    ],
  }
];

const FolderTree = ({ node, onImageClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    if (node.type === "folder") setIsOpen((prev) => !prev);
    if (node.type === "image") onImageClick(node.url);
  };

  return (
    <div className="ml-4">
      <div
        className="flex items-center gap-2 cursor-pointer text-md text-gray-700"
        onClick={toggle}
      >
        {node.type === "folder" ? (
          <>
            {isOpen ? <FiChevronDown /> : <FiChevronRight />}
            <FiFolder className="text-[#E2B007]" />
            <span>{node.name}</span>
          </>
        ) : (
          <>
            <FiImage className="text-blue-500" />
            <span>{node.name}</span>
          </>
        )}
      </div>

      <AnimatePresence>
        {isOpen && node.children && (
            <motion.div
            className="ml-4 mt-1"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            >
            {node.children.map((child) => (
                <FolderTree key={child.id} node={child} onImageClick={onImageClick} />
            ))}
            </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};

const FolderSystem = () => {
  const { setTitle } = usePageTitle();
        
  useEffect(() => {
    setTitle('Pastas');
  }, [setTitle]);

  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");


  const handleImageClick = (url) => {
    setSelectedImage(url);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const handleDownload = (e) => {
    e.preventDefault();

    if (!selectedImage) return;

    const link = document.createElement("a");
    link.href = selectedImage;
    link.download = selectedImage.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const filterNodes = (nodes, term) => {
    return nodes
        .map((node) => {
        if (node.type === "image" && node.name.toLowerCase().includes(term.toLowerCase())) {
            return node;
        }

        if (node.type === "folder" && node.children) {
            const filteredChildren = filterNodes(node.children, term);
            if (filteredChildren.length > 0 || node.name.toLowerCase().includes(term.toLowerCase())) {
            return { ...node, children: filteredChildren };
            }
        }

        return null;
        })
        .filter(Boolean);
    };
    const filteredData = searchTerm.trim() ? filterNodes(mockData, searchTerm) : mockData;

  return (
    <div>
        <Input
          type="text"
          size="xs"
          variant="search"
          value={searchTerm}
          label="Pesquisar"
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      <div className="mt-8">
        {filteredData.map((node) => (
          <div key={node.id} className="mb-4 p-4 rounded-tr-2xl rounded-tl-2xl rounded-br-2xl border">
            <FolderTree node={node} onImageClick={handleImageClick} />
          </div>
        ))}
      </div>
        <BaseForm
            isOpen={showModal}
            onClose={closeModal}
            submitButtonText="Download"
            title="Visualização de Imagem"
            onSubmit={handleDownload}
            isValid={!!selectedImage}
        >
            <div onClick={(e) => e.stopPropagation()}>
                <img src={selectedImage} alt="Nenhuma visualização disponível" className="max-w-full max-h-[80vh] rounded" />
            </div>
        </BaseForm>
    </div>
  );
};

export default FolderSystem;
